const getters = {
    doctorInfo: (state: { user: { doctorInfo: object } }) =>
        state.user.doctorInfo,
    chinaCode: (state: { user: { chinaCode: Array<object> } }) =>
        state.user.chinaCode,
};

export default getters;
